// extracted by mini-css-extract-plugin
export default {"h5":"OGDHaPse","roboto":"AdpdHwV7"};